/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReInputs */

const en_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const es_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const fr_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re :`)
};

const de_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re:`)
};

const ja_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`件名:`)
};

const zh_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于：`)
};

const ar_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رداً على:`)
};

const id_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const it_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const ru_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const pt_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re:`)
};

const ko_re = /** @type {(inputs: ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re:`)
};

/**
* | output |
* | --- |
* | "re:" |
*
* @param {ReInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const re = /** @type {((inputs?: ReInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_re(inputs)
	if (locale === "es") return es_re(inputs)
	if (locale === "fr") return fr_re(inputs)
	if (locale === "de") return de_re(inputs)
	if (locale === "ja") return ja_re(inputs)
	if (locale === "zh") return zh_re(inputs)
	if (locale === "ar") return ar_re(inputs)
	if (locale === "id") return id_re(inputs)
	if (locale === "it") return it_re(inputs)
	if (locale === "ru") return ru_re(inputs)
	if (locale === "pt") return pt_re(inputs)
	return ko_re(inputs)
});